import { Link } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import Logo from '../../../components/common/Logo';
import './authLayout.css'; // Importamos el CSS personalizado

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="auth-container">
      <div className="auth-content">
        {/* Logo y branding - Centralizado en la parte superior */}
        <div className="logo-container">
          <Link to="/" className="text-decoration-none">
            <Logo size="medium" showText={false} />
          </Link>
          <p className="tagline">
            Desarrollamos tu línea exclusiva de productos
          </p>
        </div>
        
        <div className="auth-card">
          <div className="auth-card-body">
            {/* Header */}
            <div className="auth-header">
              <FaUserCircle className="auth-icon" size={48} />
              <h2 className="auth-title">{title}</h2>
              {subtitle && <p className="auth-subtitle">{subtitle}</p>}
            </div>

            {/* Contenido */}
            <div className="auth-form-container">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
